import { RolesDataTable } from '../types';

import {DefaultRoutes} from '@data-access/shared';


export const DEFAULT_ROUTES: DefaultRoutes[] = [
  {
    name: "Study Roles",
    path: "/admin/roles/study-roles"
  },
  {
    name: "Site Roles",
    path: "/admin/roles/site-roles"
  },
  {
    path: '/admin/roles/organization-roles',
    name: 'Org Roles',
  },
  {
    name: "Internal Roles",
    path: "/admin/roles/internal-roles"
  }
];

export const DataTable: RolesDataTable = {
  data: [],
  headers: []
};
